import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 10rem 5rem 0 35rem;

    @media (min-width: 1600px) {
      margin: 8rem 5rem 0 35rem;
    }
    /* posição navegação */
    @media only screen and (max-width: 480px) {
      margin: 0 1rem 0 1rem;
    }
    @media only screen and (max-width: 978px) {
      margin: 0 1rem 0 1rem;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    line-height: 1.2;

    @media only screen and (max-width: 500px) {
      font-size: 1.3rem;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding-bottom: 1rem;
    border-bottom: 0.3rem solid ${theme.colors.lineBlue};

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media only screen and (max-width: 998px) {
      margin-top: 8rem;
    }
  `}
`;

export const BoxUser = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: center;

    ${Description} {
      color: ${theme.colors.gray};
      font-style: normal;
    }

    @media (min-width: 1600px) {
      margin-top: 1.8rem;
      ${Description} {
        font-size: ${theme.font.sizes.medium};
      }
    }
  `}
`;

export const Image = styled.img`
  margin-right: 1.5rem;
  height: 4rem;

  @media (min-width: 1600px) {
    height: 4rem;
  }

  @media only screen and (max-width: 500px) {
    height: 2.8rem;
    margin-left: 2.2rem;
  }
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.grayFour};
    font-weight: bold;

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.large};
    }
  `}
`;

export const Content = styled.div`
  max-width: 40%;
  margin: 0 auto;
  margin-top: 4rem;

  @media (max-width: 768px) {
    max-width: 70%;
  }

  @media (min-width: 768px) {
    max-width: 58%;
  }

  @media only screen and (max-width: 500px) {
    min-width: 90%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: 6rem;
  width: 90%;

  > button {
    margin-left: 1.8rem;
  }

  .inativar {
    background-color: red;
  }

  @media (min-width: 1600px) {
    margin-top: 5rem;
    flex-wrap: inherit;
  }

  @media (max-width: 1600px) {
    flex-wrap: inherit;
  }
`;

export const InputBox = styled.div`
  ${({ columns = "2fr 1fr", gap = "2rem" }) => css`
    display: grid;
    grid-template-columns: ${columns};
    gap: ${gap};
    width: 90%;
  `}
`;

export const TextAreaBox = styled.div`
  ${({ theme }) => css`
    width: 90%;
  `}
`;

export const SubTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    margin-top: 4rem;
    display: flex;
    flex-direction: column;
    font-family: Roboto;
    font-weight: 500;

    &::after {
      content: "";
      display: block;
      width: 90%;
      height: 0.3rem;
      border-bottom: 2px solid #a1a1a1;

      margin-top: 0.1rem;
    }

    @media (min-width: 1600px) {
      font-size: 2rem;
      margin-top: 6rem;
    }
  `}
`;

//

export const Containerbox = styled.div`
  width: 90%;
  height: 42px;
  /* margin: 66px 252px 41.4px 150px; */
  padding: 11.2px 4px 8.8px 31px;
  border-radius: 6px;
  border: solid 1px #707070;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TitleBox = styled.p`
  width: auto;
  height: 18px;
  margin: auto 69px auto auto;
  opacity: 0.9;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #747576;

  @media (max-width: 1418px) {
    margin: auto;
    display: flex;
    align-items: center;
    font-size: 1.1rem;
  }

  @media (min-width: 860px) {
    font-size: 1.1rem;
  }
`;

export const ClassInput = styled.div`
  display: flex;
  align-items: center;
`;

export const InputRadio = styled.input`
  width: 17.5px;
  height: 17.5px;
  padding: 4.6px 4.8px 4.9px 4.7px;
  background-color: #747576;

  @media (max-width: 1300px) {
    width: 10px;
    width: 12px;
  }
`;

export const LabelInput = styled.label`
  margin: 3px 40px 2px 6px;
  opacity: 0.9;
  font-family: Roboto;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  color: #747576;
  width: 17.5px;
  height: 17.5px;
  /* padding: 4.6px 4.8px 4.9px 4.7px; */
  @media (min-width: 768px) {
    html {
      font-size: 50%;
    }
  }
`;
export const LabelCheckBox = styled.div`
  margin-top: 1.5rem;
  font-family: Roboto;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  color: #747576;
  #checkbox {
    position: relative;
    bottom: 2.6rem;
    left: 5rem;
  }
`;
export const PasswordFields = styled.div`
  ${({ theme }) => css`
    width: 100%;
  `}
`;
